import { useWindowInnerWidth } from 'src/tools/hooks/useWindowInnerWidth';

export const MAX_MOBILE_WIDTH_PX = 500;

export function useIsMobile() {
  const windowInnerWidth = useWindowInnerWidth();
  return windowInnerWidth <= MAX_MOBILE_WIDTH_PX;
}
